<template>
  <div
    class="tabs-container"
    @mouseenter="stopAutoPlay"
    @mouseleave="handleMouseLeave"
    v-loading="loading"
  >
    <!-- 顶部 Tab 切换区域 -->
    <div class="operation-module">
      <h3 class="recommend-title"><span>为您推荐</span></h3>
      <div class="tabs">
        <span
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['tab', { active: activeIndex === index }]"
          @click="changeTab(index)"
        >
          {{ tab.name }}
        </span>
      </div>
    </div>

    <!-- 内容切换区域，使用 transition 添加 fade 动画 -->
    <div class="wrapper-100">
      <transition name="fade" mode="out-in">
        <!-- 用 key 强制刷新 -->
        <div :key="activeIndex" class="content-wrapper">
          <div
            v-if="currentContents.length"
            class="cards-grid"
          >
            <div
              v-for="(item, idx) in currentContents"
              :key="idx"
            >
              <!-- 论文卡片 -->
              <div class="paper-content-card"
                   v-if="item.type === 'paper'"
                   @click="toPaperDetail(item.data.id)"
              >
                <h4 class="title" :title="item.data.title">{{ item.data.title }}</h4>
                <p class="p2">出版物：{{ item.data.venue || '-' }}</p>
                <div class="p3">
                  <p>摘要：{{ item.data.abst || '-' }}</p>
                </div>

                <p class="p1">
                  <span>
                    <i class="el-icon-alarm-clock"></i>发表时间：{{ item.data.date || item.data.year || '-' }}
                  </span>
                  <span>引用：{{ item.data.citationNum || '-' }}</span>
                </p>
              </div>

              <!-- 专家卡片 -->
              <div class="scholar-content-card" 
                   v-else-if="item.type === 'scholar'"
                   @click="toScholarDetail(item.data.id)"
              >
                <div class="inner">
                  <el-avatar
                    class="avatar"
                    :size="60"
                    :src="item.data.avatar"
                  />
                  <div class="scholar-infor">
                  <div class="name">
                    <b>{{ item.data.name }}</b>
                  </div>

                  <p class="common-class org">所在机构：{{item.data.org_name || '-'}}</p>

                  <div class="common-class scholar-title">
                    <label>职称：</label>
                    <p v-if="item.data.showTitle && item.data.showTitle.length">
                      <span v-for="(tit, indx) in item.data.showTitle" :key="indx">{{tit}}；</span>
                    </p>
                    <p v-else>-</p>
                  </div>

                  <div class="common-class field">
                    <label>研究领域：</label>
                    <p v-if="item.data.fields && item.data.fields.length">
                      <span v-for="(field, indx) in item.data.fields" :key="indx">{{field.name}}；</span>
                    </p>
                    <p v-else>-</p>
                  </div>

                  <div class="common-class count-number">
                    <p>成果数：{{item.data.publications_count}}</p>
                    <p>引用数：{{item.data.citedby}}</p>
                    <!-- <p>H指数：{{item.data.hIndex}}</p>-->
                  </div>

                </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <el-empty />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { findPaperListApi } from '@/api/chat';

export default {
  name: 'HomeRecommend',
  props: {
    // 控制是否自动播放，父组件可动态改变这个值
    startPlay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Tab 标签
      tabs: [
        { name: '信息科学', value: '信息科学', id: 18718757104 },
        { name: '医学', value: '医学', id: 41009168 },
        { name: '生物学', value: '生物学', id: 41005072 },
        { name: '材料科学', value: '材料科学', id: 53496 },
        { name: '物理学', value: '物理学', id: 41226440 },
        { name: '化学', value: '化学', id: 18268201080 },
        { name: '数学', value: '数学', id: 41988112 },
        { name: '地质学', value: '地质学', id: 41717960 },
      ],

      // 对应每个 Tab 的内容
      contents: {
        '信息科学': [],
        '医学': [],
        '生物学': [],
        '材料科学': [],
        '物理学': [],
        '化学': [],
        '数学': [],
        '地质学': [],
      },

      loading: false,

      activeIndex: 0,  // 当前激活的 Tab 索引
      timer: null,     // 计时器，用于自动切换
      interval: 20000, // 自动切换的时间间隔（20秒）
    };
  },
  computed: {
    currentTab() {
      return this.tabs[this.activeIndex] || {};
    },
    currentContents() {
      return this.currentTab.name ? (this.contents[this.currentTab.name] || []) : [];
    }
  },
  watch: {
    // 监听父组件传入的 startPlay 值，动态开启/关闭自动播放
    startPlay(newVal) {
      if (newVal) {
        this.startAutoPlay();
      } else {
        this.stopAutoPlay();
        setTimeout(() => {
          this.activeIndex = 0;
        }, 500);
      }
    },
  },
  mounted() {
    // 从vue原型上获取 btnListData
    // this.tabs = this.$langData[this.$currentLang].chatPage.tabs;
    // this.contents = this.$langData[this.$currentLang].chatPage.contents;


    // 初始化时，如果 startPlay 为 true，则开启自动播放
    if (this.startPlay) {
      this.startAutoPlay();
    }

    this.getPaperList();
  },
  beforeDestroy() {
    // 组件销毁前，清除定时器，避免内存泄漏
    this.stopAutoPlay();
  },
  methods: {
    // 跳转论文详情
    toPaperDetail(id) {
      let obj = {
        name: 'paperDetail',
        query: { id },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },

    // 跳转人物详情
    toScholarDetail(id) {
      let obj = {
        name: 'talentDetail',
        query: { id },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },

    // 开始自动播放
    startAutoPlay() {
      // 防止重复开启
      this.stopAutoPlay();
      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.tabs.length;
      }, this.interval);
    },

    // 停止自动播放
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 点击 Tab 手动切换
    changeTab(index) {
      this.activeIndex = index;
    },

    // 鼠标移出时，如果 startPlay 为 true，则恢复自动播放
    handleMouseLeave() {
      if (this.startPlay) {
        this.startAutoPlay();
      }
    },

    // 获取最新文献列表
    async getPaperList() {
      this.loading = true;

      // 准备所有请求
      const requests = this.tabs.map((tab) =>
        findPaperListApi({
          field_id: [tab.id],
          field_name: [tab.value],
        }).then((res) => ({
          name: tab.name,
          data: res || [],
        }))
      );

      // 赋值
      try {
        const results = await Promise.all(requests);
        results.forEach((result) => {
          // console.log(result);
          this.contents[result.name] = result.data;
          // this.loading[result.name] = false; // 加载完成
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error('获取文献列表失败', e);
      }
    },
  },
};
</script>

<style scoped lang="less">
.tabs-container {
  margin: 0 auto;
  min-width: 1100px;
  padding: 50px 0 0;

  .operation-module {}

  .recommend-title {
    background: transparent;
    text-align: center;
    font-size: 20px;
    color: #333;
  }

  .tabs {
    display: flex;
    gap: 10px;
    margin: 20px;
    justify-content: center;
  }

  .tab {
    cursor: pointer;
    padding: 8px;
    //background: #f5f5f5;
    transition: 0.3s;
    font-size: 16px;
  }

  .tab.active {
    //background: #409eff;
    color: #2f70ff;
    font-weight: bold;
    padding-bottom: 5px;
    border-bottom: 3px solid #2f70ff;
  }
}

.wrapper-100 {
  width: 100%;
  background-color: #ffffff;
  padding: 50px 0 30px;
  border-radius: 8px;
}

.content-wrapper {
  margin: 0 auto;
  background: #ffffff;
  padding: 0 20px;

  .cards-grid {
    column-count: 3; // 列数
    column-gap: 20px; // 列间距

    .paper-content-card {
      display: inline-block;
      width: 100%;
      margin-bottom: 20px;
      cursor: pointer;
      background: white;
      text-align: left;
      padding: 15px;
      box-sizing: border-box;
      border-radius: 8px;
      border: 1px solid #ffffff;
      backdrop-filter: blur(12px);
      box-shadow: 0 2px 8px #6874ad40;

      &:hover {
        transform: scale(1.01);
        transition: all 0.2s ease;
        box-shadow: 0 0 10px #bbb;
      }

      .title {
        line-height: 22px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      > p {
        margin-top: 15px;
        font-size: 14px;
        color: #888888;
        line-height: 20px;
      }

      .p1 {
        display: flex;
        span {
          margin-right: 30px;
          display: flex;
          align-items: center;

          i {
            padding-right: 4px;
            font-size: 17px;
          }
        }
      }

      .p3 {
        margin-top: 15px;
        padding: 10px 15px;
        text-align: justify;
        background-color: #f4f7fa;
        border-radius: 5px;

        p {
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 21px;
          color: #333333;
          font-size: 14px;
        }
      }
    }

    .scholar-content-card {
      display: inline-block;
      width: 100%;

      .inner {
        margin-bottom: 20px;
        cursor: pointer;
        background: white;
        text-align: left;
        padding: 15px;
        border-radius: 8px;
        border: 1px solid #ffffff;
        backdrop-filter: blur(12px);
        box-shadow: 0 2px 8px #6874ad40;
        display: flex;

        &:hover {
          transform: scale(1.01);
          transition: all 0.2s ease;
          box-shadow: 0 0 10px #bbb;
        }
      }

      .avatar {
        flex-shrink: 0;
      }

      .scholar-infor {
        padding-left: 10px;

        .name {
          font-size: 18px;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 10px;

          b {
            margin-right: 10px;
          }
        }

        .common-class {
          margin-top: 5px;
          font-size: 14px;
          color: #333333;
          line-height: 22px;
        }

        .scholar-title {
          display: flex;
          //flex-wrap: wrap;

          > label {
            flex-shrink: 0;
          }

          > p {
            display: flex;
            flex-wrap: wrap;
          }
        }

        .field {
          display: flex;
          flex-wrap: nowrap;

          > label {
            flex-shrink: 0;
          }

          > p {
            display: flex;
            flex-wrap: wrap;

            span {
              color: #1241C9;
            }
          }
        }

        .count-number {
          display: flex;

          > p{
            margin-right: 30px;
          }
        }
      }
    }
  }
}

.tabs-container {
  //@media (min-width: 1000px) {
  //  .content-wrapper {
  //    width: 1000px;
  //  }
  //}
  //
  //@media (min-width: 1600px) {
  //  .cards-grid {
  //    grid-template-columns: repeat(3, 1fr); /* 3列 */
  //  }
  //  .content-wrapper {
  //    width: 1200px;
  //  }
  //}
  //
  //@media (min-width: 1800px) {
  //  .content-wrapper {
  //    width: 1350px;
  //  }
  //}
}

/* fade 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
